import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DropdownInput } from '@smooved/ui';
import { Observable, of } from 'rxjs';
import { InterviewInitiatedByType } from '../enums/interview-initiated-by-type.enum';
import { Answers } from '../interfaces/data/answers';
import { SurveysSandbox } from '../sandboxes/surveys.sandbox';

@Injectable()
export abstract class SurveyService {
    public realEstateGroupName: string;

    constructor(protected surveysSandbox: SurveysSandbox) {}

    public beforeSurveyStart(_route: ActivatedRouteSnapshot): Observable<boolean> {
        this.surveysSandbox.setInitiatedBy(InterviewInitiatedByType.Admin);
        return of(true);
    }

    public beforeSurveyNextPage<T>(_formData?: T): Observable<boolean> {
        return of(true);
    }

    public onSurveyComplete(_survey: Answers): Observable<boolean> {
        return of(true);
    }

    public afterSurveyComplete(): void {}

    public getContactPersonList<T>(): Observable<DropdownInput<T>[]> {
        return of([]);
    }

    public onSurveyNotFound(): void {
        this.surveysSandbox.goToStart();
    }

    public reset(): void {
        this.surveysSandbox.reset();
    }
}
